import React, { useMemo } from "react";
import { Flex, Typography } from "antd";
import { groupRegularTestsByCategory } from "./utils";
import "./RegularTestsGroupedView.css";

const { Text } = Typography;

export default function RegularTestsGroupedView({ regularTests, className = "" }) {
  const groupedRegularTests = useMemo(
    () => groupRegularTestsByCategory(regularTests),
    [regularTests],
  );
  const categoryOnlyTests = useMemo(() => new Set(
    (regularTests || [])
      .filter((spec) => spec?.match_scope === "test_category")
      .map((spec) => spec.test_category),
  ), [regularTests]);

  const rootClassName = ["QcRegularTestsGrouped", className].filter(Boolean).join(" ");

  if (groupedRegularTests.length === 0) {
    return (
      <div className="QcRegularTestsGrouped__Empty">
        <Text type="secondary">No regular tests defined</Text>
      </div>
    );
  }

  return (
    <div className={rootClassName}>
      <Flex vertical gap={12}>
        {groupedRegularTests.map(({ category, names }) => {
          const isCategoryOnly = categoryOnlyTests.has(category);
          return (
            <div className="QcRegularTestsGrouped__Item" key={category}>
              <Text strong>{isCategoryOnly ? category : `${category}:`}</Text>
              {!isCategoryOnly && <Text>{names}</Text>}
            </div>
          );
        })}
      </Flex>
    </div>
  );
}
